/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnalysisHistoryDTO } from '../models/AnalysisHistoryDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AnalysisHistoryService {

    /**
     * List history of analysis
     * @param workspaceId
     * @param analysisId
     * @returns AnalysisHistoryDTO
     * @throws ApiError
     */
    public static analysisHistoryControllerListHistoryOfAnalysis(
        workspaceId: string,
        analysisId: string,
    ): CancelablePromise<Array<AnalysisHistoryDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: 'workspaces/{workspaceId}/analysis/{analysisId}/history',
            path: {
                'workspaceId': workspaceId,
                'analysisId': analysisId,
            },
        });
    }

}
